module.exports = __webpack_public_path__ + "img/cisco.4ed8086a.png";